'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
var fontIcon$1 = require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
var fontIcon = require('../../icon/font-icon/font-icon.js');
var td = require('../standard-table/td.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const StyledFontIcon = styled__default.default(fontIcon.FontIcon)`
  float: right;
  padding-top: 2px;
`;
const StyledTd = styled__default.default(td.Td)`
  text-align: right;

  // Default the column to be as narrow as possible
  width: 42px; // at least the drag indicator icon width
  white-space: nowrap;
`;
const DndHandleTd = ({ children , showHandle , ...otherProps })=>{
    return /*#__PURE__*/ React__default.default.createElement(StyledTd, _extends({}, otherProps), showHandle && /*#__PURE__*/ React__default.default.createElement(StyledFontIcon, {
        icon: fontIcon$1.FontIcons.DragIndicator
    }), /*#__PURE__*/ React__default.default.createElement("span", {
        style: {
            visibility: showHandle ? 'hidden' : 'visible'
        }
    }, children));
};

exports.DndHandleTd = DndHandleTd;
//# sourceMappingURL=dnd-handle-td.js.map
